import axios from 'axios';

const URL = process.env.REACT_APP_API_URL;  // Base URL ของ API

const axiosInstance = axios.create({
    baseURL: URL,
    headers: {
        'content-type': 'application/json',
    },
});

// Middleware สำหรับ Request (ใส่ Token และตรวจสอบอื่น ๆ)
axiosInstance.interceptors.request.use(
    (config) => {
        // const account = JSON.parse(localStorage.getItem('account'));
        // if (account?.access_token) {
        //     config.headers['authorization'] = `${account.access_token}`;
        // }
        //console.log('Request:', config); // Debug Request
        return config;
    },
    (error) => {
        console.error('Request Error:', error);
        return Promise.reject(error);
    }
);

// Middleware สำหรับ Response (ตรวจจับข้อผิดพลาดและจัดการ)
axiosInstance.interceptors.response.use(
    async (response) => {
        //console.log('Response:', response);
        sessionStorage.setItem('notification',response.data?.data?.is_notification);
        return response; // Return เฉพาะข้อมูลที่ Component ต้องใช้
    },
    async (error) => {
        //console.error('Response Error:', error.response?.data || error.message);

        // ตรวจจับ Error 401 (Unauthorized) แล้ว Logout หรือทำอย่างอื่น
        if (error.response?.status === 401) {
            //console.warn('Unauthorized! Logging out...');

            // await AppError.error("Error",error.response?.data?.error?.message || "เกิดข้อผิดพลาดบางอย่าง", 
            //     async (result) => {
            //         sessionStorage.removeItem('notification');
            //         sessionStorage.removeItem('hasVisited');
            //         sessionStorage.removeItem('lastPath');
            //         localStorage.removeItem('account');
            //         window.location.replace('/');
            //     }
            // );
        }

        return Promise.reject(error);
    }
);

export default axiosInstance;
